
$(document).ready(function () {
$('.li_sub_megamenu').hover(function() 
{
	var sub_megamenu = $(this).parents('.sub_megamenu');

	setNewAttr($(this), sub_megamenu);

}, function(){

	var sub_megamenu = $(this).parents('.sub_megamenu');

	setOldAttr(sub_megamenu);

});
});



function setNewAttr(elem, sub_megamenu) 
{
	var new_img = elem.find('.hidden_img').text().trim();
	var new_menu_content = elem.find('.hidden_menu_content').text().trim();
	var new_menu_shortcontent = elem.find('.hidden_menu_shortcontent').text().trim();

	if (new_img.length > 0) {
		sub_megamenu.find('.img_megamenu img').attr('src', new_img);
	}
	else {
		var old_img = sub_megamenu.find('.old_img').text().trim();
		sub_megamenu.find('.img_megamenu img').attr('src', old_img);	}

	if (new_menu_content.length > 0) {
		sub_megamenu.find('.menu_content').text(new_menu_content);
	}
	else {
		var old_menu_content_text = sub_megamenu.find('.old_menu_content').text();
		sub_megamenu.find('.menu_content').text(old_menu_content_text);
	}

	if (new_menu_shortcontent.length > 0) {
		sub_megamenu.find('.menu_megamenu').text(new_menu_shortcontent);
	}
	else {
		var old_menu_shortcontent = sub_megamenu.find('.old_menu_megamenu').text();
		sub_megamenu.find('.menu_megamenu').text(old_menu_shortcontent);
	}
}

function setOldAttr(sub_megamenu) 
{
	var old_img = sub_megamenu.find('.old_img').text().trim();
	sub_megamenu.find('.img_megamenu img').attr('src', old_img);

	var old_menu_content_text = sub_megamenu.find('.old_menu_content').text().trim();
	sub_megamenu.find('.menu_content').text(old_menu_content_text);

	var old_menu_shortcontent = sub_megamenu.find('.old_menu_megamenu').text().trim();
	sub_megamenu.find('.menu_megamenu').text(old_menu_shortcontent);
}

